module.exports = __webpack_public_path__ + "fonts/Gilroy-Bold.58f1495.woff2";